// client/src/utils/itemCategoryKey.ts
//
// MIRRORED FILE — twin of src/utils/itemCategoryKey.js. Change one, change
// both; src/__tests__/mirroredUtilParity.test.js compares them.
//
// The stored spelling of an item category: lowercase snake_case. The server's
// vocabulary keys are built with the same function, so the picker can tell
// that a legacy `Engine Stores` IS `engine_stores` and that `Electronics` and
// `electronics` are one value (USC-BUG-0015).

export function normalizeCategoryKey(raw: unknown): string {
  return String(raw ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

// The DEPARTMENT a category belongs to (owner, 2026-09-29: the quotation Excel's
// sections), in the order the departments are listed — read by the confirmed
// order's Section Totals card (C1, QUO-00241). See the server twin.
export const DEPARTMENTS: ReadonlyArray<{ key: string; label: string }> = Object.freeze([
  { key: 'provisions', label: 'Provisions' },
  { key: 'cabin_stores', label: 'Cabin Stores' },
  { key: 'deck_stores', label: 'Deck Stores' },
  { key: 'engine_stores', label: 'Engine Stores' },
  { key: 'bonded_stores', label: 'Bonded Stores' },
  { key: 'other_stores', label: 'Other Stores' },
]);
const OTHER_DEPARTMENT = 'other_stores';
// A Map, not an object: a category spelled "constructor" must not find Object.prototype's.
const DEPARTMENT_OF_CATEGORY: ReadonlyMap<string, string> = new Map([
  ['provisions', 'provisions'],
  ['provision', 'provisions'],
  ['cabin_stores', 'cabin_stores'],
  ['cabin', 'cabin_stores'],
  ['deck_stores', 'deck_stores'],
  ['engine_stores', 'engine_stores'],
  ['bonded_stores', 'bonded_stores'],
]);

/** Which department a category belongs to; anything else, blank included, is Other Stores. */
export function departmentOf(category: unknown): string {
  return DEPARTMENT_OF_CATEGORY.get(normalizeCategoryKey(category)) || OTHER_DEPARTMENT;
}
